import { useUnit } from "effector-react"
import { Checkbox, Textarea } from "@callcenter/design-system"
import { t } from "i18next"

import { feedbackModel } from "../../models"
import { FeedbackReason } from "../../shared/types"
import { FEEDBACK_REASON_LABELS } from "../../shared/constants"

import styles from "./feedback-modal.module.pcss"

export const FeedbackForm = () => {
  const formValue = useUnit(feedbackModel.$formValue)
  const formErrors = useUnit(feedbackModel.$formErrors)
  const actions = useUnit({ handleChange: feedbackModel.handleChange })

  const toggleReason = (reason: FeedbackReason) => {
    const newReasons = new Set(formValue.reasons)

    if (newReasons.has(reason)) {
      newReasons.delete(reason)
    } else {
      newReasons.add(reason)
    }
    actions.handleChange({ name: "reasons", value: newReasons })
  }

  return (
    <div className={styles.checkboxGroup}>
      {Object.entries(FEEDBACK_REASON_LABELS).map(([reason, label]) => (
        <div key={reason} className={styles.checkboxItem}>
          <Checkbox
            isValue={formValue.reasons.has(reason as FeedbackReason)}
            onChange={() => toggleReason(reason as FeedbackReason)}
          >
            {t(label)}
          </Checkbox>

          {reason === FeedbackReason.missingFeatures && formValue.reasons.has(FeedbackReason.missingFeatures) && (
            <Textarea
              placeholder={t("component_commonKeys_feedbackModal_missingFeaturesPlaceholder")}
              value={formValue.missingFeaturesText}
              onChange={(value) => actions.handleChange({ name: "missingFeaturesText", value })}
              isError={Boolean(formErrors.missingFeaturesText)}
              hint={formErrors.missingFeaturesText}
              resizeDirection="none"
              minHeight={69}
            />
          )}

          {reason === FeedbackReason.other && formValue.reasons.has(FeedbackReason.other) && (
            <Textarea
              placeholder={t("component_commonKeys_feedbackModal_otherPlaceholder")}
              value={formValue.otherText}
              onChange={(value) => actions.handleChange({ name: "otherText", value })}
              isError={Boolean(formErrors.otherText)}
              hint={formErrors.otherText}
              resizeDirection="none"
              minHeight={69}
            />
          )}
        </div>
      ))}
    </div>
  )
}
